import React from 'react';

const ActivityLogTable = ({ rawDataString }) => {
  // Test fallback string (added a completely blank 'Test Field' at the end to demonstrate hiding)
  const dataString = rawDataString || "";

  // 1. Parse the raw string into a key-value object
  const parsedData = dataString.split(',').reduce((acc, item) => {
    const [key, ...valueParts] = item.split(':');
    if (key) {
      acc[key.trim()] = valueParts.join(':').trim();
    }
    return acc;
  }, {});

  // 2. Dynamically extract all unique column names
  const uniqueColumns = new Set();
  Object.keys(parsedData).forEach((key) => {
    if (key.startsWith('Old ')) {
      uniqueColumns.add(key.substring(4)); // Removes "Old "
    } else if (key.startsWith('New ')) {
      uniqueColumns.add(key.substring(4)); // Removes "New "
    }
  });

  // 3. Build rows and filter out if BOTH values are blank
  const visibleRows = Array.from(uniqueColumns)
    .map((colName) => {
      const oldVal = parsedData[`Old ${colName}`] || '';
      const newVal = parsedData[`New ${colName}`] || '';
      return { name: colName, oldVal, newVal };
    })
    .filter((row) => row.oldVal.trim() !== '' || row.newVal.trim() !== '');

  return (
    <div style={{ overflowX: 'auto', fontFamily: 'Roboto, Arial, Times New Roman, Calibri, sans-serif' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #dcdcdc' }}>
        <thead>
          <tr style={{ backgroundColor: '#f3f3f3', textAlign: 'left'}}>
            <th style={headerCellStyle}>Column</th>
            <th style={headerCellStyle}>Old Value</th>
            <th style={headerCellStyle}>New Value</th>
          </tr>
        </thead>
        <tbody>
          {visibleRows.map((row, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #e0e0e0' }}>
              <td style={bodyCellStyle}>{row.name}</td>
              <td style={bodyCellStyle}>{row.oldVal}</td>
              <td style={bodyCellStyle}>{row.newVal}</td>
            </tr>
          ))}
          {visibleRows.length === 0 && (
            <tr>
              <td colSpan="3" style={{ ...bodyCellStyle, textAlign: 'center', color: '#888' }}>
                No changes recorded.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

// Spreadsheet-like styles
const headerCellStyle = {
  padding: '2px 4px',
  fontWeight: 'bold',
  fontSize: '12px',
  border: '1px solid #dcdcdc',
  color: '#797878'
};

const bodyCellStyle = {
  padding: '2px 4px',
  fontSize: '12px',
  border: '1px solid #e0e0e0',
  color: '#797878'
};

export default ActivityLogTable;

